// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5689":"195ab10d","7569":"fe7dcbc0","8927":"f3567f1a"}[chunkId] + ".chunk.css";
};